import { type IllustrationSize } from './BaseIllustration.types'

export const getSize = (size: IllustrationSize): number =>
  ({
    large: 320,
    medium: 230,
    small: 150,
  })[size]
